export const ARCHIVE = 'data-archive'
export const ARCHIVE_TARGET = 'data-archive-target'
export const ARCHIVE_PAGINATION = 'data-archive-pagination'
export const ARCHIVE_LOADING = 'data-archive-loading'
export const ARCHIVE_POSTS_PER_PAGE = 'data-archive-per-page'
export const ARCHIVE_BUTTON = 'data-archive-button'
export const ARCHIVE_DATA = 'data-archive-data'
export const ARCHIVE_POST_TYPE = 'data-post-type'
export const ARCHIVE_PARENT_TAX_SLUG = 'data-parent-tax-slug'
export const ARCHIVE_TAX_SLUG = 'data-tax-slug'
export const ARCHIVE_TAX_ID = 'data-term-id'
export const ARCHIVE_ACTION = 'filter_archive'
export const ARCHIVE_PAGINATION_PAGE = 'data-page'
export const ARCHIVE_SEARCH = 'data-archive-search'